import { ErrorsValuesType, UpdatedValues } from './PeriodInput.types';
import { PeriodType } from '../../services/LimitsService.schemas';

export const validateField = (
  values: UpdatedValues[],
  setErrors: React.Dispatch<React.SetStateAction<ErrorsValuesType>>,
) => {
  const dailyLimit = Number(
    values.find((item) => item.period === 'Daily')?.amount,
  );
  const weeklyLimit = Number(
    values?.find((item) => item.period === 'Weekly')?.amount,
  );
  const monthlyLimit = Number(
    values?.find((item) => item.period === 'Monthly')?.amount,
  );

  const newErrors: ErrorsValuesType = {};

  const isDailyLimitValid = dailyLimit > 0;
  const isWeeklyLimitValid = weeklyLimit > 0;
  const isMonthlyLimitValid = monthlyLimit > 0;

  // Validate daily limit
  if (isDailyLimitValid) {
    if (dailyLimit > weeklyLimit && isWeeklyLimitValid) {
      newErrors.Daily = 'dailyLimitMoreThanWeekly';
    } else if (dailyLimit > monthlyLimit && isMonthlyLimitValid) {
      newErrors.Daily = 'dailyLimitMoreThanMonthly';
    }
  }

  // Validate weekly limit
  if (isWeeklyLimitValid) {
    if (weeklyLimit < dailyLimit && isDailyLimitValid) {
      newErrors.Weekly = 'weeklyLimitLessThanDaily';
    } else if (weeklyLimit > monthlyLimit && isMonthlyLimitValid) {
      newErrors.Weekly = 'weeklyLimitMoreThanMonthly';
    }
  }

  // Validate monthly limit
  if (isMonthlyLimitValid) {
    if (monthlyLimit < weeklyLimit && isWeeklyLimitValid) {
      newErrors.Monthly = 'monthlyLimitLessThanWeekly';
    } else if (monthlyLimit < dailyLimit && isDailyLimitValid) {
      newErrors.Monthly = 'monthlyLimitLessThanDaily';
    }
  }

  setErrors(newErrors);
};

export const isEmpty = (obj: object): boolean => Object.keys(obj).length === 0;

export const updateFieldValue = (
  prev: UpdatedValues[],
  field: PeriodType,
  value: string,
  type: UpdatedValues['type'],
) => {
  const numericValue = value.replace(/[^0-9]/g, '');
  const amount = numericValue.length ? Number(numericValue) : null;

  const fieldExists = prev.some((item) => item.period === field);

  return fieldExists
    ? prev.map((item) => (item.period === field ? { ...item, amount } : item))
    : [
        ...prev,
        {
          period: field,
          amount,
          type,
        },
      ];
};
